import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import airbnb from "../../Assets/Projects/airbnb.png";
import onnbikes from "../../Assets/Projects/onnbikes.png";
import hashnode from "../../Assets/Projects/hashnode.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px",flexDirection:"column" }}>
        <Col className="project-card" style={{maxWidth:"750px", margin:"auto"}}>
            <ProjectCard
              imgPath={hashnode}
              isBlog={false}
              title="hashnode"
              description="A blogging platform where users can blog, share ideas and connect with other people."
              about="Hashnode is a free developer blogging platform that allows you to publish articles on your own domain and helps you stay connected with a global developers."
              link="https://hash-node.vercel.app/"
              codelink="https://github.com/pawanpatidar21/hashnode_clone"
            />
          </Col>

          <Col className="project-card" style={{maxWidth:"750px", margin:"auto"}}>
            <ProjectCard
              imgPath={airbnb}
              isBlog={false}
              title="airbnb"
              description="A web app that allows users homestays for vacation rentals and tourism activities."
              about="Airbnb, Inc. is an American company that operates an online marketplace for lodging, primarily homestays for vacation rentals, and tourism activities."
              link="https://airbnb-clone-one-weld.vercel.app/"
              codelink="https://github.com/ks-1007/Airbnb-clone"
            />
          </Col>

          <Col className="project-card" style={{maxWidth:"750px",margin:"auto"}}>
            <ProjectCard
              imgPath={onnbikes}
              isBlog={false}
              title="onnbikes"
              description="A web app that allows users to book a bike for rental purposes."
              about="ONN Bikes is the most affordable bike rental company in India. They specialize in motorcycle rental, from short-term motorbike rental to long-term hiring or leasing, from bike tours to bike maintenance and service."
              link="https://rahul3105.github.io/Onn_bikes_clone/"
              codelink="https://github.com/Rahul3105/Onn_bikes_clone"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
